import { render, staticRenderFns } from "./LinkVariant.vue?vue&type=template&id=4aeedd72&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinkVariant.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/LinkVariant.vue
// module id = 2415
// module chunks = 1